import { apiClient } from '../client';

export const authService = {
  login: async (email: string, password: string) => {
    const response = await apiClient.post('/login', { email, password });
    return response.data;
  },
  logout: async () => {
    const response = await apiClient.post('/logout');
    return response.data;
  },
  refreshToken: async (refresh_token: string) => {
    const response = await apiClient.post('/refresh-token', { refresh_token });
    return response.data;
  },
};
